export const BLOCK = "block";
